if (window && window.__webpack_asset_path) { //eslint-disable-line
    __webpack_public_path__ = window.__webpack_asset_path; //eslint-disable-line
}

import 'console-shim';

import {LocalizationContext, mergeLocalizationDataAltStore} from 'epic-localization/src/context/LocalizationContext';

import App from './App';
import {BrowserRouter} from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import alt from './alt';
import pako from 'pako';
import root from 'window-or-global';
import {setLocale} from 'epic-common/src/locale';

const reactDomEle = root.document.getElementById('spyjinxReactWrapper');

// only proceed if the react ele exists
if (reactDomEle) {
    const altState = root.__epic_client_state;
    if (altState && typeof altState === 'string') {
        setLocale(root.__locale);
        // Inflate the compressed state. This is done to reduce network size and prevent XSS in the page src.
        const preload = JSON.parse(pako.inflate(altState.split(','), {to: 'string'}));
        alt.bootstrap(preload);
        const i18nContext = mergeLocalizationDataAltStore(preload.LocalizationStore);
        ReactDOM.hydrate(
            (<BrowserRouter>
                <ScrollToTopOnUpdate>
                <LocalizationContext.Provider value={i18nContext}>
                    <App />
                </LocalizationContext.Provider>
                </ScrollToTopOnUpdate>
                </BrowserRouter>
            ),reactDomEle
        );
    }
}
